import { Flex, Grid, Img, Link, Text } from "@chakra-ui/react";
import { Redirect } from "react-router-dom";
import ProductsData from "./ProductsData";
import StoreFooter from "./StoreFooter";
import Lottie from 'lottie-react'

const StoreData = ({ store }) => {
  if (!store) return <Redirect to="/404" />;

  if (!store.visible)
    return (
      <Flex
        flex={1}
        justifyContent="center"
        alignItems="center"
        flexDir="column"
        minH={"100vh"}
      >
        <Lottie
          animationData={require("./construction.json")}
          loop={true}
          autoplay={true}
        />
        <h1>{store.name} está en construcción</h1>
        <h1>Vuelve más tarde</h1>
        <Flex mt='20px'>
          <Text fontSize=".8em" fontWeight="500">
            Powered by <Link href="/">Skyshops</Link> © {new Date().getFullYear()}
          </Text>
        </Flex>
      </Flex>
    );

  return (
    <Flex flex={1} w="100%" alignItems="center" flexDir={"column"}>
      <Flex
        w="100%"
        h={{ base: "200px", md: "250px" }}
        pos="relative"
        justifyContent="center"
        alignItems="center"
        flexDir={"column"}
      >
        <Img
          objectFit={"contain"}
          src={store.logo}
          alt={store.name}
          w="100px"
          h="100px"
          bgColor="white"
          borderRadius={"50%"}
          zIndex={2}
          boxShadow="lg"
        />
        <Img
          top={0}
          zIndex={1}
          pos="absolute"
          alt={store.name}
          objectFit={"cover"}
          src={store.banner}
          w={"100%"}
          h={"100%"}
        />
      </Flex>
      <Flex 
        p="20px" 
        w="100%"
        flexDir={"column"}
      >
        <Text fontSize='2em' fontWeight='200' >{store.name}</Text>
        <Text>
          {store.description}
        </Text>

        <Flex 
          borderRadius='10px'
          mt='20px' bg='gray.100' w='100%' minH='400px'
          flexDir='row'
          p='30px'
        >
          <ProductsData store={store}/>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default StoreData;
